
export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <div className="text-purple-600 text-sm font-bold uppercase tracking-wider mb-3">
            THE PROBLEM WITH TRADITIONAL CAR BUYING
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-4">
            <span className="text-gray-800">Most Canadians Don't Know</span>
            <br />
            <span className="italic text-purple-600">Brokers Exist</span>
            <br />
            <span className="text-gray-900">And It's Costing Them Thousands</span>
          </h2>
          <p className="text-lg text-gray-600 mt-6 max-w-3xl mx-auto">
            Here's how we're changing the game in <strong>Woodbridge</strong> & beyond
          </p>
        </header>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Hours Saved Card */}
          <article className="relative bg-gradient-to-br from-orange-400 to-orange-500 rounded-3xl p-12 text-white overflow-hidden group hover:shadow-2xl transition-all">
            <div className="relative z-10">
              <div className="text-8xl font-serif font-bold mb-2">40+</div>
              <h3 className="text-3xl font-bold mb-3">HOURS SAVED</h3>
              <p className="text-xl mb-8 opacity-90"><strong>Average time saved</strong> per customer</p>
              <div className="text-lg italic opacity-80">
                "Time is money, we save you both"
              </div>
            </div>
            <button className="absolute top-6 right-6 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </button>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/10 rounded-full"></div>
          </article>

          {/* Money Saved Card */}
          <article className="relative bg-gradient-to-br from-purple-400 to-purple-500 rounded-3xl p-12 text-white overflow-hidden group hover:shadow-2xl transition-all">
            <div className="relative z-10">
              <div className="text-8xl font-serif font-bold mb-2">$3,500</div>
              <h3 className="text-3xl font-bold mb-3">AVERAGE SAVINGS</h3>
              <p className="text-lg leading-relaxed opacity-90">
                By leveraging <strong>executive relationships at 50+ dealerships</strong> across Ontario, we negotiate deals you can't access alone
              </p>
            </div>
            <button className="absolute top-6 right-6 w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer">
              <i className="ri-arrow-right-up-line text-2xl"></i>
            </button>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/10 rounded-full"></div>
          </article>
        </div>

        {/* About Me Section */}
        <article className="mt-20 bg-white rounded-3xl p-12 shadow-lg max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/9a6691600f1ad591dca57aa038c94df9.jpeg"
                alt="Professional Auto Broker in Woodbridge Ontario"
                title="Auto Broker Woodbridge Ontario"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
            <div>
              <h3 className="text-4xl font-bold text-gray-900 mb-6">About Me</h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p className="text-lg">
                  I'm an experienced <strong>Auto Broker</strong> based in <strong>Woodbridge, Ontario</strong>, and I've made it my mission to revolutionize how Canadians buy cars.
                </p>
                <p className="text-lg">
                  Most people spend weeks visiting dealerships, negotiating prices, and dealing with high-pressure sales tactics. They don't realize there's a better way.
                </p>
                <p className="text-lg">
                  With direct access to top-level executives at over <strong>50 dealerships across Ontario</strong>, I negotiate deals that save my clients an average of <strong>$3,500 and 40+ hours</strong> of their time.
                </p>
                <p className="text-lg font-semibold text-purple-600">
                  The best part? The dealership never knows you're working with a broker, so you get the best possible price without any hassle.
                </p>
              </div>
              <div className="mt-8 flex items-center space-x-4">
                <div className="flex items-center space-x-2 text-gray-600">
                  <i className="ri-map-pin-line text-xl text-purple-600"></i>
                  <span><strong>Woodbridge, Ontario</strong></span>
                </div>
                <div className="flex items-center space-x-2 text-gray-600">
                  <i className="ri-car-line text-xl text-purple-600"></i>
                  <span>500+ Cars Brokered</span>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
